import { useMemo } from 'react'

import Hostname from './Hostname'
import resolveAppointmentKinds from '../helpers/tasks/resolveAppointmentKinds'

/**
 * De soorten afspraak van deze organisatie, zichtbaar en op volgorde: de
 * instelling (`CompagnyMeta.AppointmentKinds`) gelegd over de ingebouwde
 * soorten van het merk van de omgeving (alleen FIXtool heeft die).
 *
 * Leeg zolang het merk nog laadt — dat valt dicht (vrije tekst), niet open.
 * Neemt de `useSettings()`-uitkomst van het scherm aan in plaats van zelf te
 * lezen: een tweede aanroep is een tweede stel listeners op hetzelfde document.
 * Roep aan op schermniveau, niet per rij.
 * AI-CONTEXT: See docs/features/afspraak-soort-en-aanwezigheid-bkb.md
 *
 * @param {{appointmentKindsConfig?: object}} [settings] - Uitkomst van `useSettings()`
 * @returns {Array<import('../helpers/tasks/resolveAppointmentKinds').AppointmentKind>}
 */
const useAppointmentKinds = (settings) => {
    const appointmentKindsConfig = settings && settings.appointmentKindsConfig
    const host = Hostname()
    const brand = (host && host.Name) || ''

    return useMemo(
        () => resolveAppointmentKinds({ AppointmentKinds: appointmentKindsConfig }, { brand }),
        [appointmentKindsConfig, brand],
    )
}

export default useAppointmentKinds
